import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { declineAgreementSignature } from './listingRequestEndpoints'
import { parseAgreement } from './listingRequestParser'
import { listingRequestKeys } from './listingRequestQueryKeys'
import type { AgreementSignatureTarget } from '../types/listingRequestTypes'

interface DeclineSignatureVariables extends AgreementSignatureTarget {
  reason?: string
}

// Records a signatory declining to sign, then refreshes agreements + detail +
// timeline. The container owns the dialog and toggles it closed on success.
export function useDeclineAgreementSignatureMutation(id: MaybeRefOrGetter<string>) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (variables: DeclineSignatureVariables) =>
      declineAgreementSignature(
        toValue(id),
        variables.agreementId,
        variables.signatoryId,
        variables.reason ? { reason: variables.reason } : {},
      ).then(parseAgreement),
    onSuccess: () => {
      const requestId = toValue(id)
      queryClient.invalidateQueries({ queryKey: listingRequestKeys.agreements(requestId) })
      queryClient.invalidateQueries({ queryKey: listingRequestKeys.detail(requestId) })
      queryClient.invalidateQueries({ queryKey: listingRequestKeys.timeline(requestId) })
    },
  })
}
